<div class="table-perc-progress">
    <div class="table-perc-progress-value">
        {{perc | decimalFormat: 1:0:0}}%
    </div>
    <div class="progress">
        <div class="progress-bar" role="progressbar"
            [style.width]="perc + '%'"
            [attr.aria-valuenow]="perc" aria-valuemin="0" aria-valuemax="100">
        </div>
    </div>
</div>